export const getStressLevel = (score: number) => {
  if (score < 7) {
    return 'stresstest.result_overview.stresslevel_explanation.0-7-points.label';
  }
  if (score < 14) {
    return 'stresstest.result_overview.stresslevel_explanation.8-15-points.label';
  }
  return 'stresstest.result_overview.stresslevel_explanation.15-21-points.label';
};
